export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/icons/end_of_plan_preview_icon-eae027ee64f719310a5b9d42482866e2.svg";